import React, {useCallback} from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Stack,
    Select,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useItemVariant} from '.'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {getPriceData} from '@salesforce/retail-react-app/app/utils/product-utils'
import PricePerItem from './price-per-item'
import {useIntl} from 'react-intl'

const ItemAttributes = ({includeQuantity, currency, ...props}) => {
    const intl = useIntl()
    const styles = useMultiStyleConfig('ItemAttributes')
    const variant = useItemVariant()
    const {data: basket} = useCurrentBasket()
    const {currency: activeCurrency} = useCurrency()

    const {price, priceAfterItemDiscount} = variant
    const isASet = variant?.type?.set
    const isMaster = variant?.type?.master
    const localeCountry = intl?.locale?.split('-')[1]?.toLowerCase() || intl?.locale?.toLowerCase()
    let priceData
    if (variant?.itemId) {
        priceData = {
            currentPrice: priceAfterItemDiscount,
            listPrice: null,
            pricePerUnit: variant?.pricePerUnit,
            isASet,
            isMaster,
            isRange: isASet || isMaster || false,
            isOnSale: price > priceAfterItemDiscount
        }
    } else {
        priceData = getPriceData(variant)
    }

    const getEcoTax = useCallback(
        (categoryType) => {
            if (categoryType === 'system') {
                return intl.formatMessage({
                    id: 'order_summary.pricesummary.system',
                    defaultMessage: 'Including 1 Swiss franc as ecotax Electronic waste'
                })
            } else if (categoryType === 'lift') {
                return intl.formatMessage({
                    id: 'order_summary.pricesummary.lift',
                    defaultMessage: 'Including CHF 2.50 as ecotax Electronic waste'
                })
            } else if (categoryType === 'steamer') {
                return intl.formatMessage({
                    id: 'order_summary.pricesummary.steamer',
                    defaultMessage: 'Including CHF 0.60 as ecotax Electronic waste'
                })
            } else {
                return ''
            }
        },
        [intl]
    )

    return (
        <Stack {...styles.attributeBox} {...props}>
            {includeQuantity && (
                <Flex {...styles.flexBox}>
                    <Select
                        {...styles.attributeBox.select}
                        value={variant.quantity}
                        icon=""
                        isDisabled
                    >
                        <option value={variant.quantity}>{variant.quantity}</option>
                    </Select>

                    {variant?.quantity > 0 && !isASet && priceData?.pricePerUnit && (
                        <Flex {...styles.ecoText}>
                            <PricePerItem
                                currency={currency || basket?.currency || activeCurrency}
                                price={
                                    basket?.productItems?.find(
                                        (item) => item.productId === variant.productId
                                    )?.basePrice
                                }
                            />
                            {['fr', 'be', 'ch'].includes(localeCountry) && (
                                <Text {...styles.ecoTaxText}>
                                    {getEcoTax(variant.c_categoryType)}
                                </Text>
                            )}
                        </Flex>
                    )}
                </Flex>
            )}
        </Stack>
    )
}

ItemAttributes.propTypes = {
    includeQuantity: PropTypes.bool,
    currency: PropTypes.string
}

export default ItemAttributes
